module.exports = __webpack_public_path__ + "img/SketchPngfde1f62598caf7870214f6ea76dcb531550a76b33dbf4c02826ef5643ef124ae.8e8716bd.png";